import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import MyTasks from "@/pages/MyTasks";
import MyAssignedTasks from "@/pages/MyAssignedTasks";
import { ViewModeToggle } from "@/components/tasks/ViewModeToggle";
import { SectionExplainerVideo } from "@/components/common/SectionExplainerVideo";
import BatonPassTasks from "@/components/tasks/BatonPassTasks";

/**
 * The Task Center body, no MainLayout wrapper. Mounted inside the Governance
 * Tasks tab and reused by any legacy /my-tasks entry point.
 */
export default function TaskCenterContent() {
  const [searchParams] = useSearchParams();
  const [viewMode, setViewMode] = useState<"created" | "assigned">(() => {
    const urlView = searchParams.get("view");
    if (urlView === "created" || urlView === "assigned") return urlView;
    const savedView = localStorage.getItem("taskCenterViewMode");
    return savedView === "created" || savedView === "assigned" ? savedView : "assigned";
  });

  const handleViewModeChange = (mode: "created" | "assigned") => {
    setViewMode(mode);
    localStorage.setItem("taskCenterViewMode", mode);
  };

  return (
    <div className="space-y-6">
      <SectionExplainerVideo
        videoUrl="https://vimeo.com/1152239446"
        sectionKey="task-center"
        title="Task Center Overview"
        description="Learn how to manage your personalized action items and tasks"
      />

      <div className="flex flex-col gap-4">
        <div>
          <h2 className="text-2xl md:text-3xl font-bold mb-1">Tasks</h2>
          <p className="text-muted-foreground text-sm md:text-base">
            Your personalized action items, including advisor recommendations, board tasks, and items you have created.
          </p>
        </div>
        <div className="flex justify-start">
          <ViewModeToggle mode={viewMode} onChange={handleViewModeChange} />
        </div>
      </div>

      <BatonPassTasks />





      <div>
        <div style={{ display: viewMode === "created" ? "block" : "none" }}>
          <MyTasks />
        </div>
        <div style={{ display: viewMode === "assigned" ? "block" : "none" }}>
          <MyAssignedTasks />
        </div>
      </div>
    </div>
  );
}
